export default [
    {
        path: '/clockIn/index',
        component: (resolve) => require(['@/components/clockIn/Index'],resolve),
        meta: {
            title: '打卡列表'
        },
    },
    {
        path: '/clockIn/commit',
        component: (resolve) => require(['@/components/clockIn/Commit'],resolve),
        meta: {
            title: '打卡提交'
        },
    },
    {
        path: '/clockIn/activity',
        component: (resolve) => require(['@/components/clockIn/Activity'],resolve),
        meta: {
            title: '打卡活动'
        },
    },
    {
        path: '/clockIn/detail',
        component: (resolve) => require(['@/components/clockIn/Detail'],resolve),
        meta: {
            title: '打卡主题'
        },
    },
    {
        path: '/clockIn/comment',
        component: (resolve) => require(['@/components/clockIn/Comment'],resolve),
        meta: {
            title: '打卡评论'
        },
    },
]


// WEBPACK FOOTER //
// ./src/router/clockIn.js